const typographyCalendar = {
  clearFilterButton: 'Clear'
};

export default typographyCalendar;
